import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { InformationsContainerBlockConfig } from '@front-platform/content-builder';
import { informationsContainerBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface InformationsContainerBlockRuntimeConfig {
  'columns'?: any;
}

export type InformationsContainerBlockConfigInput = Partial<
  Omit<InformationsContainerBlockConfig, keyof InformationsContainerBlockRuntimeConfig> &
    InformationsContainerBlockRuntimeConfig
>;
export type InformationsContainerBlockResolvedConfig = Omit<
  InformationsContainerBlockConfig,
  keyof InformationsContainerBlockRuntimeConfig
> &
  Partial<InformationsContainerBlockRuntimeConfig>;
export interface InformationsContainerBlockContract extends ConfigComponentContract<
  InformationsContainerBlockConfigInput,
  InformationsContainerBlockResolvedConfig
> {}

@Component({
  selector: 'app-informations-container-block',
  templateUrl: './informations-container-block.component.html',
  standalone: false,
})
export class InformationsContainerBlockComponent implements InformationsContainerBlockContract {
  readonly config = input<InformationsContainerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    InformationsContainerBlockConfig,
    InformationsContainerBlockRuntimeConfig
  >(informationsContainerBlockResolveConfig, () => ({ config: this.config() }));
  get columns(): any {
    return this.resolvedConfig()['columns'] as unknown as any;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(InformationsContainerBlockComponent, {
  'keyAliases': {},
});
